module.exports = __webpack_public_path__ + "img/COM-i-1-II.7fbc0623.png";